import type { FloorSystem } from '../../shared/schemas';

interface Props {
  system: FloorSystem;
  selected: string;
  asset(rel: string): string;
  onSelect(id: string): void;
}

export function ColorGrid({ system, selected, asset, onSelect }: Props) {
  return (
    <div id="fv-colors" role="radiogroup" aria-label={`${system.name} colors`} class="grid grid-cols-4 gap-x-2.5 gap-y-3 sm:grid-cols-6">
      {system.colors.map((c) => {
        const active = c.id === selected;
        return (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onSelect(c.id)}
            class="group flex flex-col items-center gap-1.5 text-center"
          >
            <span
              class={`relative block aspect-square w-full overflow-hidden rounded-xl ring-offset-2 transition ${
                active ? 'ring-[3px] ring-brand' : 'ring-1 ring-black/10 group-hover:ring-black/30'
              }`}
            >
              <img src={asset(c.thumb)} alt="" width={160} height={160} loading="lazy" class="h-full w-full object-cover" />
              {active && (
                <span class="absolute right-1 top-1 grid h-5 w-5 place-items-center rounded-full bg-brand text-brand-text shadow" aria-hidden="true">
                  <svg viewBox="0 0 16 16" class="h-3 w-3" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M3.5 8.5l3 3 6-7" />
                  </svg>
                </span>
              )}
            </span>
            <span class={`text-xs leading-tight ${active ? 'font-semibold text-ink' : 'text-muted'}`}>{c.name}</span>
          </button>
        );
      })}
    </div>
  );
}
